import SigamAPI from '~/utils/SigamAPI';

export default async function CreateChat({ person_id, institutionId }) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/chat`,
    method: 'POST',
    data: {
      person_id,
    },
  });

  return response;
}
